import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { Platform } from 'react-native';
import KnowledgeScreen from '../screens/MidLevel/KnowledgeScreen/KnowledgeScreen';
import ComingSoonScreen from '../screens/NonMenu/ComingSoonScreen';
import EditKnowledgeScreen from '../screens/LowLevel/KnowledgeEditorScreen';
import { KnowledgeStackParamList } from '../types';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import ChatBotScreen from '../screens/MidLevel/ChatBotScreen/ChatBotScreen';
import FlowMenu from '@navigation/screens/MidLevel/DataScreen/ActionHandler/FlowDesigner/FlowMenu';
import FlowDesigner from '@navigation/screens/MidLevel/DataScreen/ActionHandler/FlowDesigner/Screens/FlowHandlerScreen';
import CallFlows from '@navigation/screens/MidLevel/DataScreen/ActionHandler/FlowDesigner/CallFlows';
// ManualFlows and SalesFlows components don't exist, using FlowMenu for now
// import ManualFlows from '@navigation/screens/MidLevel/DataScreen/ActionHandler/FlowDesigner/ManualFlows';
// import SalesFlows from '@navigation/screens/MidLevel/DataScreen/ActionHandler/FlowDesigner/SalesFlows';

// Import FlowEditor
import FlowEditor from '@navigation/screens/MidLevel/DataScreen/ActionHandler/FlowDesigner/FlowEditor';
import JournalEntryScreen from '../screens/MidLevel/JournalEntryScreen/JournalEntryScreen.native';
import UserUploadedDocumentsScreen from '../screens/MidLevel/KnowledgeScreen/UserUploadedDocumentsScreen';
import KnowledgeMenu from '../screens/MidLevel/KnowledgeScreen/KnowledgeMenu';

const KnowledgeStack = createStackNavigator<KnowledgeStackParamList>();

const KnowledgeNavigator = () => {
  const theme = themeSelector();

  return (
    <KnowledgeStack.Navigator
      screenOptions={{ headerShown: false, cardStyle: { backgroundColor: Platform.select({ web: theme ? "white" : "black", default: "transparent" }) } }}>
      <KnowledgeStack.Screen
        name="KnowledgeMenu"
        component={KnowledgeMenu}
        options={{ headerTitle: 'Knowledge Menu' }} />
      <KnowledgeStack.Screen
        name="KnowledgeScreen"
        component={KnowledgeScreen}
        options={{ headerTitle: 'Knowledge' }} />
      <KnowledgeStack.Screen
        name="InternalKnowledge"
        component={KnowledgeScreen}
        options={{ headerTitle: 'Knowledge' }} />
      <KnowledgeStack.Screen
        name="ChatBot"
        component={ChatBotScreen}
        options={{ headerTitle: 'ChatBot' }} />
      <KnowledgeStack.Screen
        name="Flows"
        component={FlowMenu}
        options={{ headerTitle: 'Flows' }} />
      <KnowledgeStack.Screen
        name="ManualFlows"
        component={FlowMenu}
        options={{ headerTitle: 'Manual Flows' }} />
      <KnowledgeStack.Screen
        name="SalesFlows"
        component={FlowMenu}
        options={{ headerTitle: 'Sales Flows' }} />
      <KnowledgeStack.Screen
        name="CallFlows"
        component={CallFlows}
        options={{ headerTitle: 'Call Flows' }} />
      <KnowledgeStack.Screen
        name="FlowDesigner"
        component={FlowDesigner}
        options={{ headerTitle: 'Flow Designer' }} />
      <KnowledgeStack.Screen
        name="FlowEditor"
        component={FlowEditor}
        options={{ headerTitle: 'Flow Editor' }} />
      <KnowledgeStack.Screen
        name="ExternalKnowledge"
        component={ComingSoonScreen}
        options={{ headerTitle: 'Knowledge' }} />
        <KnowledgeStack.Screen
        name="EditKnowledge"
        component={EditKnowledgeScreen}
        options={{ headerTitle: 'Edit Knowledge' }} />
      <KnowledgeStack.Screen
        name="JournalEntry"
        component={JournalEntryScreen}
        options={{ headerTitle: 'Journal Entry' }} />
      <KnowledgeStack.Screen
        name="UserUploadedDocuments"
        component={UserUploadedDocumentsScreen}
        options={{ headerTitle: 'Uploaded Documents' }} />
    </KnowledgeStack.Navigator>
  );
}
export { KnowledgeStack, KnowledgeNavigator }